import React, { useState } from 'react'
import _, { isEmpty ,isNull } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../utils/hooks'

const PresetCategoryForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        engName: formData.engName,
        position: formData.position
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          engName: values.engName,
          position: values.position
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  return (
    <Modal
    title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Preset Category`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Name">
          {getFieldDecorator(`name`, {
          })(<Input
            name="name"
            placeholder="ชื่อ" />)}
        </Form.Item>
        <Form.Item label="English Name">
          {getFieldDecorator(`engName`, {
          })(<Input
            name="engName"
            placeholder="ชื่อภาษาอังกฤษ" />)}
        </Form.Item>
        <Form.Item label="ลำดับ">
          {getFieldDecorator(`position`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            type="number"
            name="position"
            placeholder="ลำดับ" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
               Save
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedPresetCategoryForm = Form.create({ name: 'PresetCategoryForm' })(
  PresetCategoryForm
)
export default WrappedPresetCategoryForm